import { Box, PopoverProps, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { forwardRef } from 'react';

import { WIDGET_DRAG_ICON, WIDGET_DRAG_ICON_TOOLTIP } from '../../constants';
import { getState } from '../../store';
import { DragIconSvg } from './DragIconSvg';
import { DragIconSvgEditor3 } from './DragIconSvgEditor3';

type DragIconProps = Readonly<{
  isDetached: boolean | undefined;
  isEditor3?: boolean;
  isStudio?: boolean;
}>;

const dragIconTooltipMoveBy: PopoverProps['moveBy'] = { y: 6 };

export const DragIcon = forwardRef<HTMLDivElement, DragIconProps>(
  ({ isDetached, isEditor3, isStudio }, ref) => {
    const { t } = useTranslation();
    const { initParams } = getState();
    // tooltip only appears before the user drags the widget;
    const tooltipDisabled = !initParams.isInvokedFromHeader || isDetached;
    const dragIconColor = isEditor3 ? '#151414' : isStudio ? 'black' : 'white';

    return (
      <Box position="absolute" width="100%" align="center">
        <Tooltip
          content={t('drag_icon_tooltip_content')}
          size="small"
          maxWidth="100%"
          moveBy={dragIconTooltipMoveBy}
          disabled={tooltipDisabled}
          dataHook={WIDGET_DRAG_ICON_TOOLTIP}
          fluid
        >
          <Box
            ref={ref}
            cursor="move"
            color={dragIconColor}
            dataHook={WIDGET_DRAG_ICON}
            width="100%"
            align="center"
          >
            {isEditor3 ? <DragIconSvgEditor3 /> : <DragIconSvg />}
          </Box>
        </Tooltip>
      </Box>
    );
  },
);
